'use strict';

import dispatcher from '../dispatcher';
import store from './popup.store';

let items = {};

let idName = 'popup-control-id-';
let idNum  = 1;
let active = false;





function _handleChange() {
  let storeData = store.getData();

  if (active === storeData.active) return;

  if (active && items.hasOwnProperty(active)) {
    items[active].element.classList.remove('active');
  }
  active = storeData.active;
  if (active && items.hasOwnProperty(active)) {
    items[active].element.classList.add('active');
  }
}

function _add(element) {
  let id = element.dataset.id;
  let dataPopup = element.dataset.popup;

  if (!id) {
    id = idName + idNum;
    idNum++;
  }

  if (!dataPopup) dataPopup = id;

  element.addEventListener('click', function() {
    dispatcher.dispatch({
      type: 'popup-toggle',
      id: dataPopup
    });
  }, false);

  items[id] = {
    id: id,
    element: element
  }
}


function _handleMutate() {
  let elements = document.querySelectorAll('.view-popup-toggle');

  function check(el) {
    for (let id in items) {
      if (items.hasOwnProperty(id) && items[id].element === el) {
        return;
      }
    }
    _add(el);
  }

  function backCheck(id) {
    for (let i = 0; elements.length > i; i++) {
      if (items[id].element === elements[i]) return;
    }
    delete items[id];
  }

  for (let i = 0; elements.length > i; i++) {
    check(elements[i])
  }
  for (let id in items) {
    if (items.hasOwnProperty(id)) backCheck(id);
  }
}

function init() {
  _handleMutate();
  _handleChange();

  store.eventEmitter.subscribe(_handleChange);

  dispatcher.subscribe(function(e) {
    if (e.type === 'mutate') {
      _handleMutate();
      _handleChange();
    }
  });
}

export default {
  init: init
}
